





























































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { WebhookItem } from "@/modules/webhooks/types";
import {
  FetchPaginatedPayload,
  WebhookAttempt,
} from "@/modules/webhooks/types";
import { namespace } from "vuex-class";

import Prism from "vue-prism-component";
import vueCodeditor from "vue-codeditor";
import dayjs from "dayjs";
import Paginate from "vuejs-paginate";

import CodeEditor from "@/modules/webhooks/components/CodeEditor.vue";
import { webhooks } from "../utils";

const Webhooks = namespace("webhooks");
@Component({
  components: {
    prism: Prism,
    "vue-codeditor": vueCodeditor,
    paginate: Paginate,
    "code-editor": CodeEditor,
  },
})
export default class ViewWebhook extends Vue {
  @Webhooks.Action("fetchCurrentWebhook") fetchCurrentWebhook!: (
    webhookId?: string
  ) => Promise<{}>;
  @Webhooks.Action("fetchAttemptTotals") fetchAttemptTotals!: (
    webhookId?: string
  ) => Promise<{}>;
  @Webhooks.Action("fetchPaginatedWebhookAttempts")
  fetchPaginatedWebhookAttempts!: (
    payload: FetchPaginatedPayload
  ) => Promise<{}>;
  @Webhooks.Getter("getCurrentWebhook") currentWebhook: WebhookItem;
  @Webhooks.Getter("getCurrentWebhookAttempts")
  currentWebhookAttempts: WebhookAttempt;
  @Webhooks.Getter("getTotalAttempts") totalAttempts: number;
  @Webhooks.Getter("getTotalSuceededAttempts") totalSuceededAttemts: number;
  @Webhooks.Getter("getTotalFailedAttempts") totalFailedAttempts: number;
  @Webhooks.Getter("isViewing") isViewing: string;
  @Webhooks.Action("viewAllAttempts") viewAllAttempts: () => void;
  @Webhooks.Action("viewAllSuceededAttempts")
  viewAllSuceededAttempts: () => void;
  @Webhooks.Action("viewAllFailedAttempts") viewAllFailedAttempts: () => void;

  inputType = "password";
  numberOfLines = 0;

  async beforeMount() {
    const { webhookId } = this.$route.params;
    await this.fetchCurrentWebhook(webhookId);
    await this.fetchAttemptTotals(webhookId);
    await this.viewPaginatedWebhookAttempts(1);
  }

  showMoreDetails(value: string) {
    this.$el
      .querySelector(`.chevron-${value}`)
      ?.classList.toggle("chevron-right");
    this.$el.querySelector(`#item-${value}`)?.classList.toggle("show-details");
  }

  toggleInputType() {
    this.inputType = this.inputType == "text" ? "password" : "text";
  }

  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }

  async changePage(pageIndex: number) {
    await this.viewPaginatedWebhookAttempts(pageIndex);
  }

  async viewPaginatedWebhookAttempts(pageIndex: number) {
    if (this.isViewing === "all") {
      await this.fetchPaginatedWebhookAttempts({
        pageIndex,
        filterParam: "",
      });
    } else {
      await this.fetchPaginatedWebhookAttempts({
        pageIndex,
        filterParam:
          this.isViewing === "succeeded"
            ? "&successful=true"
            : "&successful=false",
      });
    }
  }

  async viewAttempts(isViewing: string) {
    if (isViewing === "all") 
      this.viewAllAttempts();
    else if (isViewing === "succeeded") 
      this.viewAllSuceededAttempts();
    else 
      this.viewAllFailedAttempts();

    await this.viewPaginatedWebhookAttempts(1);
  }

  setNumberOfLines(lines: number) {
    this.numberOfLines = lines;
  }

  setShowLines(event: Event) {
    const revealLinesBtn = event.target as HTMLElement;
    revealLinesBtn.classList.toggle("active");
  }
}
